import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

import UploadExternalResults from '../musherRating/uploadExternalResults';

@observer
class UploadExternalResultsDrawer extends Component {
    closeDrawer = () => {
        const { callback } = this.props;
        const { appState } = this.props.stores;

        if (callback) {
            callback();
        }
        appState.toggleDrawer();
    }

    render() {
        return (
            <div class='upload-external-results-drawer h-100'>
                <div class='w-100 h-100 d-flex flex-column' style='padding-top: 20px; padding-bottom: 20px;'>

                    <div class='font-weight-lighter px-3 box-header mt-0 d-flex justify-content-between align-items-center flex-shrink-0'>
                        <span>
                            <i class='fa-solid fa-upload me-2' />
                            <Text id='musherRating.uploadResults'>Upload Results</Text>
                        </span>
                        <button
                            class='btn btn-sm btn-outline-secondary rounded-pill'
                            onClick={this.closeDrawer}
                        >
                            <i class='fa-solid fa-xmark me-1' />
                            <Text id='admin.close'>Close</Text>
                        </button>
                    </div>

                    <div class='px-3 mt-3 flex-grow-1 overflow-auto'>
                        <UploadExternalResults
                            stores={this.props.stores}
                            onComplete={this.closeDrawer}
                            fullWidth={true}
                        />
                    </div>

                </div>
            </div>
        );
    }
}

export default UploadExternalResultsDrawer;
